import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-info-dialog',
  templateUrl: './info-dialog.component.html',
  styleUrls: ['./info-dialog.component.scss']
})
export class InfoDialogComponent implements OnInit {



  ngOnInit(): void {
  }

  constructor(private dialogRef: MatDialogRef<InfoDialogComponent>) { }

  close(result: boolean) {
    this.dialogRef.close(result);
  }

}
